// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.notification-information[data-v-02d91396] {\r\n  color: var(--carbon-700) !important;\n}\n.smaller-text[data-v-02d91396] {\r\n  color: var(--carbon-900);\r\n  font-size: 14px !important;\r\n  line-height: 16px !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
